/* eslint no-underscore-dangle: 0 */
import ScreensharePreprocessor from './ScreensharePreprocessor';

/**
 * Class Implementing the effect interface expected by a JitsiLocalTrack.
 * Effect applies cropping on a video/screenshare JitsiLocalTrack.
 */
export default class CroppedScreenShareEffect extends ScreensharePreprocessor {
  /**
   * Effect interface called by source JitsiLocalTrack.
   *
   * @param {MediaStream} videoStream - Video stream which will be mixed with #mixAudio.
   * @returns {MediaStream} - MediaStream containing both video tracks mixed together.
   */

  _stream;

  startEffect(stream) {
    this._stream = stream;
    return this.cropMediaTrack(stream);
  }

  /**
   * Checks if the JitsiLocalTrack supports this effect.
   *
   * @param {JitsiLocalTrack} sourceLocalTrack - Track to which the effect will be applied.
   * @returns {boolean} - Returns true if this effect can run on the specified track, false otherwise.
   */
  /* eslint-disable-next-line */
  isEnabled(sourceLocalTrack) {
    return (
      this.isMediaProcessingSupported() &&
      sourceLocalTrack.isVideoTrack() &&
      sourceLocalTrack.videoType === 'desktop'
    );
  }

  /** TODO: Investigate how to properly clean up resources
   * Clean up resources acquired by screenshare cropping
   * @returns {void}
   */
  stopEffect() {
    this._stream = null;
  }
}
